import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './styles/app.css'   // calm-energy visual tokens + shared component system
import './styles/shell.css' // runtime behaviour overrides
import { router } from './router'
import { applyTheme, currentTheme } from './app/theme'

applyTheme(currentTheme())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
